import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

// Fotocamera SOLO dopo pressione esplicita; solo video (mai audio); anteprima obbligatoria;
// arresto immediato di tutte le tracce a conferma/annullamento/unmount. Nessun frame salvato senza conferma.
export function CameraCapture({ onUse, onClose }) {
  const { t } = useTranslation();
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [shot, setShot] = useState(null); // { url, blob }
  const [err, setErr] = useState(null);
  const [facing, setFacing] = useState("user"); // preferenza frontale (foto profilo)
  const stop = () => { streamRef.current?.getTracks().forEach(tr => tr.stop()); streamRef.current = null; };
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const s = await navigator.mediaDevices.getUserMedia({ video: { facingMode: facing }, audio: false });
        if (cancelled) { s.getTracks().forEach(tr => tr.stop()); return; }
        streamRef.current = s;
        if (videoRef.current) videoRef.current.srcObject = s;
      } catch { setErr(true); }
    })();
    return () => { cancelled = true; stop(); };
  }, [facing]);
  const shoot = () => {
    const v = videoRef.current;
    if (!v || !v.videoWidth) return;
    const canvas = document.createElement("canvas");
    canvas.width = v.videoWidth; canvas.height = v.videoHeight;
    canvas.getContext("2d").drawImage(v, 0, 0);
    canvas.toBlob(blob => setShot({ url: URL.createObjectURL(blob), blob }), "image/jpeg", 0.92);
  };
  const use = () => { stop(); onUse(shot.blob); };
  const close = () => { stop(); onClose(); };
  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={close} data-testid="camera-modal">
      <div className="yp-card p-4 w-full max-w-md" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={t("photo.camera")}>
        <h3 className="font-bold mb-3">{t("photo.camera")}</h3>
        {err ? (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded p-3" data-testid="camera-error">{t("photo.camera_error")}</div>
        ) : shot ? (
          <img src={shot.url} alt="" className="w-full rounded" data-testid="camera-preview" />
        ) : (
          <video ref={videoRef} autoPlay playsInline muted className="w-full rounded bg-black" data-testid="camera-video" />
        )}
        <div className="flex justify-between items-center mt-3 flex-wrap gap-2">
          {!err && !shot && (
            <button className="yp-btn yp-btn-ghost !py-1 !px-3 text-xs" onClick={() => setFacing(f => f === "user" ? "environment" : "user")} data-testid="camera-switch">{t("photo.switch_cam")}</button>)}
          <div className="flex gap-2 ml-auto">
            {shot && <button className="yp-btn yp-btn-ghost" onClick={() => setShot(null)} data-testid="camera-retry">{t("photo.retry")}</button>}
            {!err && !shot && <button className="yp-btn yp-btn-primary" onClick={shoot} data-testid="camera-shoot">{t("photo.shoot")}</button>}
            {shot && <button className="yp-btn yp-btn-primary" onClick={use} data-testid="camera-use">{t("photo.use")}</button>}
            <button className="yp-btn yp-btn-outline" onClick={close} data-testid="camera-cancel">{t("common.cancel")}</button>
          </div>
        </div>
      </div>
    </div>);
}
